import { MODE } from '../config';

export const consoleLog = (...params) => {
    if (MODE !== 'qa') {
        return;
    }
    // eslint-disable-next-line no-console
    console.log(
        `%c${params?.[0]}`,
        'color: aqua; background: black; font-size: 14px; font-weight: bold; border: 1px solid aqua; text-align: center; padding: 3px 15px;',
        ...(params?.slice?.(1) ?? []),
    );
};

export const stringify = (
    obj,
    maxDepth = 3,
    disabledKeys = [],
    formatted = true,
    currentDepth = 0,
    visited = new Set(),
    indent = '',
) => {
    const nextIndent = formatted ? indent + '  ' : '';
    const newline = formatted ? '\n' : '';
    const space = formatted ? ' ' : '';

    if (obj === null) {
        return 'null';
    }
    if (obj === undefined) {
        return 'undefined';
    }
    if (typeof obj === 'string') {
        return `"${obj}"`;
    }
    if (typeof obj === 'number' || typeof obj === 'boolean') {
        return String(obj);
    }
    if (typeof obj === 'function') {
        return '[Function]';
    }
    if (typeof obj === 'symbol') {
        return obj.toString();
    }

    if (visited.has(obj)) {
        return '[Circular Reference]';
    }

    if (currentDepth >= maxDepth) {
        if (Array.isArray(obj)) {
            return `[Array(${obj.length})]`;
        }
        if (obj instanceof Date) {
            return `"${obj.toISOString()}"`;
        }
        if (obj instanceof Error) {
            return `"[Error: ${obj.message}]"`;
        }
        return '[Object]';
    }

    visited.add(obj);

    try {
        if (Array.isArray(obj)) {
            if (obj.length === 0) {
                visited.delete(obj);
                return '[]';
            }

            const items = obj.map((item) =>
                stringify(item, maxDepth, disabledKeys, formatted, currentDepth + 1, visited, nextIndent),
            );

            visited.delete(obj);

            if (formatted) {
                return `[${newline}${nextIndent}${items.join(`,${newline}${nextIndent}`)}${newline}${indent}]`;
            }
            return `[${items.join(', ')}]`;
        }

        if (obj instanceof Date) {
            visited.delete(obj);
            return `"${obj.toISOString()}"`;
        }

        if (obj instanceof Error) {
            visited.delete(obj);
            return `"[Error: ${obj.message}]"`;
        }

        const entries = [];
        for (const [ key,
            value ] of Object.entries(obj)) {
            // Skip keys with undefined values
            if (value === undefined) {
                continue;
            }

            let stringifiedValue;

            if (disabledKeys.includes(key)) {
                stringifiedValue = '"...value..."';
            } else {
                stringifiedValue = stringify(
                    value,
                    maxDepth,
                    disabledKeys,
                    formatted,
                    currentDepth + 1,
                    visited,
                    nextIndent,
                );
            }

            entries.push(`"${key}":${space}${stringifiedValue}`);
        }

        visited.delete(obj);

        if (entries.length === 0) {
            return '{}';
        }

        if (formatted) {
            return `{${newline}${nextIndent}${entries.join(`,${newline}${nextIndent}`)}${newline}${indent}}`;
        }
        return `{${entries.join(', ')}}`;
    } catch (error) {
        visited.delete(obj);
        return '[Unstringifiable Object]';
    }
};
